<!-- BLOC 1: Intro normal (fără GDPR) -->
<div
  *ngIf="shouldDisplayIntro && rejectGdpr == false"
  class="container mt-0 mt-md-5"
>
  <div class="d-flex justify-content-center">
    <div
      class="card shadow-sm border-0"
      style="max-width: 720px; width: 100%; border-radius: 1rem"
    >
      <div
        class="card-body p-4 d-flex flex-column"
        style="background-color: #fff; border-radius: 1rem"
      >
        <div
          style="text-align: center"
          *ngFor="let sentence of surveySentences"
        >
          {{ sentence }}
        </div>

        <div
          class="row justify-content-center"
          style="margin-top: 40px; margin-bottom: 40px"
        >
          <button
            type="button"
            class="btn btn-success col-md-3 col-lg-3 col-xs-5 col-sm-5"
            [routerLink]="['/survey', surveyId]"
          >
            Începe
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BLOC 2: GDPR cu checkbox și buton dezactivat -->
<div
  *ngIf="!shouldDisplayIntro && rejectGdpr == false"
  class="container d-flex justify-content-center mt-5"
>
  <div
    class="card shadow-sm border-0"
    style="max-width: 720px; width: 100%; border-radius: 1rem"
  >
    <div
      class="card-body p-4 d-flex flex-column"
      style="background-color: #fff; border-radius: 1rem"
    >
      <!-- Afișăm aici textul din surveySentences -->
      <div
        style="text-align: center; margin-bottom: 20px"
        *ngFor="let sentence of surveySentences"
        style="
          text-align: center;
          margin-bottom: 20px;
          font-size: 14px;
          color: black;
        "
      >
        {{ sentence }}
      </div>

      <div class="text-center mb-2">
        <p class="text-muted small mb-0" style="color: black">
          Pentru a continua, este necesar să îți exprimi acordul cu privire la
          prelucrarea datelor cu caracter personal.
        </p>
      </div>

      <div class="form-check d-flex justify-content-start mt-2 mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="gdprAcceptCheckbox"
          (change)="onCheckboxChange($event)"
        />
        <label
          class="form-check-label ms-2 small w-100"
          for="gdprAcceptCheckbox"
          style="cursor: pointer; color: #565353; font-size: 13px"
        >
          Confirm că am citit și accept termenii și condițiile privind protecția
          datelor.
        </label>
      </div>

      <div
        class="row justify-content-center"
        style="margin-top: 40px; margin-bottom: 16px"
      >
        <button
          type="button"
          class="btn btn-success col-md-3 col-lg-3 col-xs-5 col-sm-5"
          [disabled]="!gdprAccepted"
          (click)="onStartClick()"
        >
          Începe
        </button>
      </div>

      <div class="text-center mt-2">
        <a
          href="https://www.ploom.ro/ro/politica-de-confidentialitate-si-protectia-datelor"
          target="_blank"
          rel="noopener noreferrer"
          class="small text-decoration-underline text-primary"
        >
          Vezi politica de confidențialitate
        </a>
      </div>
    </div>
  </div>
</div>

<!-- REJECTED GDPR APPROVAL  -->
<div *ngIf="rejectGdpr == true" class="container mt-0 mt-md-5">
  <div class="row">
    <div class="col-md-11 mx-auto">
      <div class="card card-signing flex-row my-5" style="border-radius: 1rem">
        <div
          class="card-body"
          style="background-color: white; border-radius: 1rem; height: 100%"
        >
          <div class="row justify-content-center">
            <div class="col-12">
              <form class="px-4" action="">
                <div class="row" style="margin-top: 20px">
                  <div
                    style="text-align: center"
                    *ngFor="let sentence of surveySentences"
                  >
                    Ne pare rau, insa nu ti-ai dat acordul cu privire la
                    prelucrarea datelor cu caracter personal, deci nu poti
                    accesa formularul nostru.
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer
  *ngIf="
    surveyType === 'PLOOM3_1' ||
    surveyType === 'PLOOM3_3' ||
    surveyType === 'PLOOM3_6' ||
    surveyType === 'PLOOM3_12' ||
     surveyType === 'PLOOM4_1' ||
    surveyType === 'PLOOM4_3' ||
    surveyType === 'PLOOM4_6' ||
    surveyType === 'PLOOM4_12'
  "
></app-footer>
